export const useProductionURL = true

export const LOGIN_STEP = {
    NEW_LOGIN: 0,
    CHOOSE_DOCKET: 1,
    FORGOT_PASSWORD: 2,
    LOAD_PREVIOUS_LOGIN: 3,
    FINISHED: 99
}

export const MC_TITLES = ["Unknown", "Priority MC" , "Other MC", "Non-MC"]
export const SENTIMENTS = ["Negative", "Mixed", "Positive"]
export const SENTIMENT_OFFSET = 1

export const REVIEW_TYPES = {
    PR: "Primary",
    QA: "QA",
    notSelected: "none"
}

export const MAX_WF_ADMIN_ROWS = 300